import React from 'react';
import { Modal, Radio, Input  } from 'antd';
import "./selectResource.scss";

const { Search } = Input;
class SelectResource extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            visible: false,
            value: 1

        }
    }
    showSelectResource = () => {
        this.setState({
            visible: true
        })
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value
        })
    }

    handleOk = () => {
        this.setState({
            visible: false
        })

    }

    handleCancel = () => {
        this.setState({
            visible: false
        })
    }

   

    render(){
        const { visible, value } = this.state;
        return(
            <Modal
                className="select-resource-modal"
                title="选择来源"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                destroyOnClose
                width={600}
            >
                <Search placeholder="" onSearch={value => console.log(value)} enterButton />
                <Radio.Group onChange={this.onChange} value={value} className="select-resource-modal-radio">
                    <Radio value={1}>AAAAAAAAAAAA</Radio>
                    <Radio value={2}>BBBBBBBBBBBB</Radio>
                    <Radio value={3}>CCCCCCCCCCCC</Radio>
                    <Radio value={4}>DDDDDDDDDDDD</Radio>
                </Radio.Group>
            </Modal>
        )
    }
}

export default SelectResource